'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$20() {
  this.beG = null;
  this.beE = null;
  this.beF = false;
  this.beC = null;
  this.beD = false;
  this.beH = false;
  this.beI = false;
  this.beG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$20 as $c_Lpresto_PrestoRouter$$anon$20 };
$p = $c_Lpresto_PrestoRouter$$anon$20.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$20;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$20() {
}
export { $h_Lpresto_PrestoRouter$$anon$20 as $h_Lpresto_PrestoRouter$$anon$20 };
$h_Lpresto_PrestoRouter$$anon$20.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ac = (function() {
  return this.beG;
});
$p.t = (function() {
  if ((!this.beF)) {
    this.beE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.beF = true;
  }
  return this.beE;
});
$p.ad = (function() {
  if ((!this.beD)) {
    this.beC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.beD = true;
  }
  return this.beC;
});
$p.v = (function() {
  if ((!this.beI)) {
    this.beH = false;
    this.beI = true;
  }
  return this.beH;
});
$p.ab = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$20 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$20, "presto.PrestoRouter$$anon$20", ({
  NU: 1,
  a: 1,
  j: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$20 as $d_Lpresto_PrestoRouter$$anon$20 };
//# sourceMappingURL=presto.-Presto-Router$$anon$20.js.map
